import {
  ContractsWhereColumn,
  OrdersWhereColumn,
  OtherDocumentsWhereColumn,
} from "@src/__generated__/urql-graphql";
import { BaseMixedFilters } from "../../documents/listing/MixedFilters";

export class MixedFilters extends BaseMixedFilters {
  constructor(projectId?: string) {
    super();

    this.where.contracts.hide([
      ContractsWhereColumn.BrandId,
      ContractsWhereColumn.ClientId,
      ContractsWhereColumn.ProjectId,
      ContractsWhereColumn.ContractorId,
    ]);
    this.where.orders.hide([
      OrdersWhereColumn.BrandId,
      OrdersWhereColumn.ProjectId,
    ]);
    this.where.otherDocuments.hide([]);

    if (projectId) {
      this.where.contracts.addImplicitFilter(
        ContractsWhereColumn.ProjectId,
        projectId,
      );
      this.where.orders.addImplicitFilter(
        OrdersWhereColumn.ProjectId,
        projectId,
      );
      this.where.otherDocuments.addImplicitFilter(
        OtherDocumentsWhereColumn.ProjectId,
        projectId,
      );
    }
  }
}
